import React from 'react';
import { Icon } from '../Icon/Icon';

export function FormsComplianceBadge() {
  return (
    <span className="inline-flex items-center gap-1 rounded-[var(--r-pill)] border border-[color-mix(in_srgb,var(--gold)_35%,var(--cream-2))] bg-[var(--gold-tint)] px-1.5 py-0.5 text-[9.5px] font-semibold uppercase tracking-wide text-[#9A6B1E]">
      <Icon kind="shield" size={10} stroke={2} />
      Compliance
    </span>
  );
}
